import { StaticTree } from "@/components/landing/StaticTree";
import { GeometricTree } from "@/components/landing/GeometricTree";
import { GeometricStarTree } from "@/components/landing/GeometricStarTree";
import { RealisticTree } from "@/components/landing/RealisticTree";
import { ArchwayGarden } from "@/components/landing/ArchwayGarden";

const statics = [
  {
    id: "A",
    title: "Savanna Acacia",
    desc: "Leaning sculptural trunk, wide flat-top umbrella crown with layered foliage. (static)",
  },
  {
    id: "B",
    title: "Grand Oak",
    desc: "Massive trunk, billowing rounded canopy with deep shadow cores and sunlit edges. (static)",
  },
  {
    id: "C",
    title: "Graceful Olive",
    desc: "Slender arching limbs, drooping silvery-green leaf strands. Calm and elegant. (static)",
  },
];

const previous = [
  {
    id: "D",
    title: "Geometric Star Tree",
    desc: "First geometric direction — eight-pointed stars blooming on a girih lattice, slow counter-rotations.",
    el: <GeometricStarTree />,
  },
  {
    id: "E",
    title: "Leaf-Rosette Tree",
    desc: "Geometric canopy built from the same leaves that float across the page, arranged as Islamic rosettes.",
    el: <GeometricTree />,
  },
  {
    id: "F",
    title: "Realistic Tree (current hero)",
    desc: "Procedural tree with tapered limbs, ~2,600 shaded leaves, wind sway, scroll gusts and canopy leaf-shedding.",
    el: <RealisticTree />,
  },
  {
    id: "G",
    title: "Archway Garden",
    desc: "Sandstone Islamic arch opening onto an animated charbagh garden (trees, water channel, fountain).",
    el: <ArchwayGarden />,
  },
];

const Card = ({ id, title, desc, children }) => (
  <div
    data-testid={`tree-design-${id}`}
    className="bg-white border border-[#122A1D]/10 shadow-[0_8px_30px_rgba(18,42,29,0.06)] p-6"
  >
    <p className="font-heading text-2xl text-[#A9842F] mb-1">
      {id} — {title}
    </p>
    <p className="text-sm text-[#5B6F64] font-light mb-4">{desc}</p>
    {children}
  </div>
);

export default function TreeDesigns() {
  return (
    <main data-testid="tree-designs-page" className="min-h-screen bg-[#F7F6F1] py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <p className="uppercase tracking-[0.35em] text-xs text-[#8C6A1F] mb-4">Design preview</p>
        <h1 className="font-heading text-4xl sm:text-5xl text-[#122A1D] mb-3">Tree design gallery</h1>
        <p className="text-[#5B6F64] font-light mb-12 max-w-xl">
          Every hero centerpiece so far. Tell me which one (A–G) to develop further or restore.
        </p>

        <h2 className="font-heading text-3xl text-[#122A1D] mb-6">New static options</h2>
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {statics.map((v) => (
            <Card key={v.id} id={v.id} title={v.title} desc={v.desc}>
              <StaticTree variant={v.id} />
            </Card>
          ))}
        </div>

        <h2 className="font-heading text-3xl text-[#122A1D] mb-6">Previous designs (animated)</h2>
        <div className="grid md:grid-cols-2 gap-8">
          {previous.map((v) => (
            <Card key={v.id} id={v.id} title={v.title} desc={v.desc}>
              <div className="flex justify-center">{v.el}</div>
            </Card>
          ))}
        </div>
      </div>
    </main>
  );
}
